export const GRID_KEYS = {
  INVESTOR_ACCOUNTS: 'investor-accounts',
  ADVISOR_ACCOUNTS: 'advisor-accounts',
  INVESTOR_CASH_FLOW: 'investor-transactions',
  INVESTOR_HOLDINGS: 'investor-holdings',
  INVESTOR_PERFORMANCE: 'investor-performance',
  INVESTOR_PORTFOLIO_DIVERSIFICATION: 'investor-pd-grid',
  INVESTOR_REALIZED_GAINS: 'investor-realized-gains',
  INVESTOR_TRADING: 'investor-trading',
  INVESTOR_UNREALIZED_GAINS: 'investor-unrealized-gains',
  ADVISOR_AGGREGATED_HOLDINGS: 'advisor-aggregated-holdings',
  ADVISOR_CLIENTS: 'advisor-clients',
  INVESTOR_MARKET_PRICING: 'investor-holdings-mp',
} as const;

export type GridKey = (typeof GRID_KEYS)[keyof typeof GRID_KEYS];
